var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 15H44.575L40 10H25V15H37.8L42.375 20H52.5V50H12.5V27.5H7.5V50C7.5 52.75 9.75 55 12.5 55H52.5C55.25 55 57.5 52.75 57.5 50V20C57.5 17.25 55.25 15 52.5 15ZM20 35C20 41.9 25.6 47.5 32.5 47.5C39.4 47.5 45 41.9 45 35C45 28.1 39.4 22.5 32.5 22.5C25.6 22.5 20 28.1 20 35ZM32.5 27.5C36.625 27.5 40 30.875 40 35C40 39.125 36.625 42.5 32.5 42.5C28.375 42.5 25 39.125 25 35C25 30.875 28.375 27.5 32.5 27.5ZM12.5 15H20V10H12.5V2.5H7.5V10H0V15H7.5V22.5H12.5V15Z",
    fill: "#9E9E9E",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPhoto);
export default __webpack_public_path__ + "static/media/addPhoto.49954c43420cf1073f4dee2b66d80dbc.svg";
export { ForwardRef as ReactComponent };